(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvIcon', drvIcon);

    drvIcon.$inject = [];
    drvIconCtrl.$inject = ['SystemService'];

    /**
     * Shows a coloured icon for a specific ChilliDocs usage, e.g. 'email' or 'document template'.
     * The icon can be specified via 'usage' or explicitly using 'icon'.
     *
     * # Scope Properties
     * {string} usage - Where the icon is being used determines which icon to return. E.g. 'email' or 'document template'. Optional.
     * {string} icon - The SVG icon to used, this will override the icon used for usage. Optional.
     * {string} colour - The icons colour, if supplied this will override the usual colour for the usage. Optional.
     */
    function drvIcon() {
        var directive = {
            restrict: 'E',
            scope: {},
            controller: drvIconCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                usage: '<?',
                icon: '<?',
                colour: '<?'
            },
            template:
                '<md-icon md-svg-icon="{{drvCtrl.iconDetails.icon}}" ng-style="{\'fill\': drvCtrl.iconDetails.iconColour}"></md-icon>'
        };
        return directive;
    }

    function drvIconCtrl(SystemService) {
        /* jshint validthis:true */
        var drvCtrl = this;
        Object.defineProperty(drvCtrl, 'iconDetails', { get: getIconDetails });

        function getIconDetails() {
            var iconDetails = {};
            if (!_.isNil(drvCtrl.icon) && drvCtrl.icon !== '') {
                iconDetails.icon = drvCtrl.icon;
            } else {
                iconDetails = SystemService.getChilliDocsIcon(drvCtrl.usage);
            }

            if (!_.isNil(drvCtrl.colour) && drvCtrl.colour !== '') {
                iconDetails.iconColour = drvCtrl.colour;
            }

            if (!_.isEqual(iconDetails, getIconDetails.iconDetails)) {
                getIconDetails.iconDetails = iconDetails;
            }

            return getIconDetails.iconDetails;
        }
    }
})();